'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ShieldCheck } from 'lucide-react';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 flex flex-col items-center justify-center p-4">
      <div className="max-w-4xl w-full space-y-8">

        {/* Header */}
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center gap-3 mb-6">
            <h1 className="text-4xl font-bold text-slate-900 tracking-tight flex items-center">
              <span style={{ transform: 'scale(1.2)', display: 'inline-block' }}>SciX<sup className="text-lg">®</sup></span>
              <span className="ml-3">oncopilot<sup className="text-lg">™</sup></span>
            </h1>
          </div>
          <div className="space-y-2">
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              癌症精准医学决策支持及可视化平台
            </p>
            <p className="text-lg text-slate-500 max-w-2xl mx-auto">
              Precision Oncology Clinical Decision Support & Visualization Platform
            </p>
          </div>
        </div>

        {/* Login Cards */}
        <div className="flex justify-center mt-12">

          {/* Provider Portal */}
          <Card className="border-slate-200 shadow-md hover:shadow-xl transition-shadow duration-300 w-full max-w-md">
            <div className="flex flex-col items-center justify-center p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-8 text-blue-600">
                <Image src="/dolphin.png" alt="Dolphin" width={32} height={32} className="text-blue-600" />
              </div>
              <Link href="/auth/login?role=doctor" className="w-full">
                <Button variant="outline" className="w-full h-12 text-lg border-emerald-200 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-800 hover:border-emerald-300">
                  Doctor / Case Manager Login
                </Button>
              </Link>
            </div>
          </Card>

        </div>

      </div>
    </div>
  );
}
